import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { LoadingService } from 'src/app/services/loading/loading.service';

import { TranslateService } from '@ngx-translate/core';
import constants from 'src/constants';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService implements HttpInterceptor {

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private loading: LoadingService,
    private authentication: AuthenticationService,
    private translate: TranslateService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if(err.status === 401) {
        // Check for specific error statuses, return the error in the body if it matches
        if (err.error && 
            (err.error.status == 'invalid_email' || err.error.status == 'email_exists' || err.error.status == 'invalid_credentials' || err.error.status == 'email_not_found')
        ) {
          return of(new HttpResponse({
            body: err.error
          }));
        }
        this.authentication.logout().then(() => {
            this.authentication.isAuthenticated.next(false);
            this.router.navigateByUrl('/login');
        });
      } else if(err.status == 403) {
        this.dialog.open(ErrorDialogComponent, {
          data: {
            message: this.translate.instant("ERROR.errorForbidden", {message: err.error.message})
          }
        });
      } else if(err.status == 412) {
        if (err.error && err.error.response_code == constants.EULA_NEEDS_APPROVAL) {
          // User must accept EULA before continuing
          this.router.navigate(['/eula'], {
            queryParams: {
              'redirectTo': this.router.url
            },
            queryParamsHandling: 'merge'
          });
        } else {
          this.dialog.open(ErrorDialogComponent, {
            data: {
              message: this.translate.instant("ERROR.errorGeneric", {message: err.error.message})
            }
          });
        }
      } else {

        this.dialog.open(ErrorDialogComponent, {
          data: {
            message: this.translate.instant("ERROR.somethingGoneWrongMessage")
          }
        });
      }

      this.loading.dismiss(); // Closes the loader if there has been an error in an API call

      return of(err.error);
    }));
  }
}
